import type { LeaseActionProps } from '../../../models/Types';
import LeaseExtension from '../../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function RedirectToLeaseRenewalCosmosSummary(props: LeaseActionProps) {
  const { history, terminateActiveAction, lease } = props;
  const latestExtension = lease?.latestExtension ? new LeaseExtension(lease.latestExtension) : null;
  const { renewalId, leaseId } = useLeasingUrlParams();

  const extensionId = renewalId || latestExtension?.id || 0;

  history.push(LeaseExtension.getWizardPath(leaseId || lease.id, extensionId));
  terminateActiveAction();
  return null;
}
